import { useQuery } from "@tanstack/react-query";
import z from "zod";

import { useApi } from "@/hooks";

import { TvQueryKeys } from "../query-keys";

import { waitForPendingStreamStop } from "./useStopChannelStream";

const channelStreamSchema = z.object({ url: z.string() });

function useChannelStream(channelId: string, enabled: boolean) {
  const api = useApi();

  async function getChannelStream(signal?: AbortSignal) {
    await waitForPendingStreamStop();

    const { data } = await api.get<{ url: string }>(
      `/api/v1/tv/channels/${channelId}`,
      { signal },
    );
    return channelStreamSchema.parse(data);
  }

  return useQuery({
    queryKey: TvQueryKeys.channelStream(channelId),
    queryFn: ({ signal }) => getChannelStream(signal),
    enabled: enabled && channelId.length > 0,
    staleTime: 60_000,
  });
}

export { useChannelStream };
